<template>
  <div style="background-color: white;height: 100vh">
    <div class="box">
      <div style="position: absolute; width: 45px; height: 45px;" @click="slip()">
        <img loading="lazy" src="../../assets/slipleft.png" />
      </div>
      <div class="ViewTitle">{{ title }}</div>
      <div class="contain gery">
        <el-form :label-position="labelPosition" label-width="100px" :model="form">
          <!-- 当 gptsUserEmail 为 null 时的简单表单 -->
          <template v-if="!gptsUserEmail || gptsUserEmail === 'null'">
            <el-form-item label="邮箱号">
              <el-input v-model="form.email" placeholder="请输入邮箱账号"></el-input>
            </el-form-item>
            <el-form-item label="验证码" class="codeBox">
              <el-input v-model="form.code" placeholder="请输入验证码"></el-input>
              <el-button type="text" :disabled="codeDisabled" class="setCode" @click="getoriginalCode()">{{ codeBtnText
              }}</el-button>
            </el-form-item>
          </template>
          <!-- 不为null的表单 -->
          <template v-else>
            <el-form-item label="旧邮箱号">
              <el-input v-model="gptsUserEmail" disabled></el-input>
            </el-form-item>
            <el-form-item label="验证码" class="codeBox">
              <el-input v-model="form.code" placeholder="请输入验证码"></el-input>
              <el-button type="text" :disabled="oldCodeDisabled" class="setCode" @click="getoldCode()">{{ oldCodeBtnText
              }}
              </el-button>
            </el-form-item>
            <el-form-item label="新邮箱号">
              <el-input v-model="form.newemail" placeholder="请输入邮箱"></el-input>
            </el-form-item>
            <el-form-item label="验证码" class="codeBox">
              <el-input v-model="form.newcode" placeholder="请输入验证码"></el-input>
              <el-button type="text" :disabled="newCodeDisabled" class="setCode" @click="getnewCode()">{{
                newCodeBtnText}}
              </el-button>
            </el-form-item>
          </template>
          <div class="submit" @click="submitnew()">确认</div>
        </el-form>
      </div>
    </div>
    <div class="islider" v-if="show">
      <bc-slider @validImg="validImg" @close="onClose" :backgroupImg="backgroupImg" :moveImg="moveImg"
        :log="true"></bc-slider>
      <!-- @getImg="getImg" -->
    </div>
  </div>
</template>
<script>
import { emailSend, captcha, captchaVerify, upEmail } from "@/api/user";
import { shareUrl } from "@/utils/vxshare.js";
import bcSlider from "@/components/sliderpc";
import {getemail,changeEmail,bindEmail} from "@/api/login";
export default {
  name: "ChangeEmail",
  components: { bcSlider },
  data() {
    return {
      changeVisable:1,
      title: "修改邮箱",
      titleEn: "Modify email",
      labelPosition: "right",
      form: {
        areaCode: "",
        email: "",
        code: "",
      },
      codeBtnText: "获取验证码",
      // 旧邮箱验证码相关
      oldCodeDisabled: false,
      oldCodeBtnText: '获取验证码',
      oldCodeCountdown: 0,
      oldCodeTimer: null,
      // 新邮箱验证码相关
      newCodeDisabled: false,
      newCodeBtnText: '获取验证码',
      newCodeCountdown: 0,
      newCodeTimer: null,

      disabled: false,
      setCode: "验证码",
      setCodeEn: "Verification code",
      languageSelect: "",
      backToken: "",
      mobile: "",
      secretKey: "",
      backgroupImg: "",
      moveImg: "",
      show: false,
      gptsUserEmail: localStorage.getItem("gptsUserEmail"),
      userId: localStorage.getItem("gptsUserId"),
      token: localStorage.getItem("token"),
    };
  },
  computed: {},
  created() {
    localStorage.setItem("myclick", 1);
    if (localStorage.getItem("language")) {
      this.languageSelect = localStorage.getItem("language");
    } else {
      this.languageSelect = "zh";
    }
    this.getImg();
    let type = this.$route.query.type;
    this.title = type == 1 ? "修改邮箱" : "绑定邮箱";
    let url = window.location.host;
    // let url = 'https://oilgasinfoai.com/?language=zh'
    setTimeout(() => {
      //encodeURIComponent 将你的URL进行转译一下，因为微信分享出去后会带有多余用不到的参数
      let shareData = {
        url: url,
        title: "油气知识",
        text: "洞悉油气行业变化，体验AI大模型，就来油气知识！",
      };
      shareUrl(shareData);
    }, 1000);
  },
  methods: {
    changeheadVisable(){
      if(this.changeVisable===1){
        this.changeVisable=0
      }
      else{
        this.changeVisable=1
      }
      console.log("父组件", this.changeVisable)
    },
    slip() {
      this.form = {
        email: "",
        code: "",
      };
      this.$router.go(-1);
    },
    onClose() {
      this.show = false;
      this.getImg();
    },
    // 获取滑动验证码（下方有格式截图）
    getImg() {
      captcha().then((res) => {
        this.backToken = res.data.token;
        this.secretKey = res.data.secretKey;
        this.backgroupImg = res.data.originalImageBase64;
        this.moveImg = res.data.jigsawImageBase64;
      });
    },
    // 操作滑动后返回值，并传去后端验证
    validImg(moveX, fn) {
      // moveX为小滑块滑动的距离
      // 330为背景图的宽度，可设置为动态变量，310是偏移量
      const moveLeftDistance = (moveX * 310) / parseInt(330);
      const data = {
        pointJson: JSON.stringify({ x: moveLeftDistance, y: 5.0 }),
        token: this.backToken,
        type: 2,
        email: this.form.email,
        // sender: this.form.phone,
      };
      captchaVerify(data)
        .then((res) => {
          const result = res;
          console.log(res.data);
          if (result.data) {
            this.onClose();
            // 调用登录的请求方法
            let data = {
              email: this.form.email,
              captchaToken: res.data,
              event:
                this.title == "修改邮箱"
                  ? "UPDATE_EMAIL_EMS"
                  : "UPDATE_EMAIL_EMS",
            };
            emailSend(data).then((respon) => {
              if (!respon.data.data) {
                this.$message({
                  message: respon.msg,
                  type: "success",
                });
                this.tackBtn(); //验证码倒数60秒
              } else {
                // console.log(data);
                let data1 = JSON.parse(respon.data.data);
                this.$message({
                  message: data1.error_msg,
                  type: "error",
                });
              }
            });
          } else {
            fn(false);
          }
        })
        .catch(() => {
          fn(false);
        });
      this.show = true;
    },
            // 获取新用户绑定邮箱的验证码
getoriginalCode() {
  if (!this.validateEmail(this.form.email)) {
    return;
  }
  this.startOriginalCodeCountdown();
  this.sendEmailCode(this.form.email, 'original');
},

// 新用户验证码倒计时
startOriginalCodeCountdown() {
  this.codeDisabled = true;
  let countdown = 60;
  this.codeBtnText = `${countdown}秒后重新获取`;
  
  const timer = setInterval(() => {
    countdown--;
    this.codeBtnText = `${countdown}秒后重新获取`;
    
    if (countdown <= 0) {
      clearInterval(timer);
      this.codeDisabled = false;
      this.codeBtnText = '获取验证码';
    }
  }, 1000);
},
          // 获取旧邮箱验证码
    getoldCode() {
      if (!this.validateEmail(this.gptsUserEmail)) {
        return;
      }
      this.startOldCodeCountdown();
      this.sendEmailCode(this.gptsUserEmail, 'old');
    },
    
    // 获取新邮箱验证码
    getnewCode() {
      if (!this.validateEmail(this.form.newemail)) {
        return;
      }
      this.startNewCodeCountdown();
      this.sendEmailCode(this.form.newemail, 'new');
    },
    
    // 邮箱账号
    validateEmail(email) {
      if (!email) {
        this.$message.error("请输入邮箱账号");
        return false;
      }
     const reg = /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;
      if (!reg.test(email)) {
        this.$message.error("请输入正确的邮箱账号");
        return false;
      }
      return true;
    },
    
    // 发送邮箱验证码
    sendEmailCode(email, type) {
      getemail({ 
        email: email,
      }).then(res => {
        if (res.code === 200) {
          this.$message.success('验证码发送成功');
        } else {
          this.$message.error(res.msg || '验证码发送失败');
          // 发送失败时重置对应按钮状态
          if (type === 'original') {
            this.codeDisabled = false;
            this.codeBtnText = '获取验证码';
          }
          else if (type === 'old') {
            clearInterval(this.oldCodeTimer);
            this.oldCodeDisabled = false;
            this.oldCodeBtnText = '获取验证码';
          } else {
            clearInterval(this.newCodeTimer);
            this.newCodeDisabled = false;
            this.newCodeBtnText = '获取验证码';
          }
        }
      }).catch(() => {
        this.$message.error('请求失败，请重试');
      });
    },
    
    // 旧邮箱倒计时
    startOldCodeCountdown() {
      this.oldCodeDisabled = true;
      this.oldCodeCountdown = 60;
      this.oldCodeBtnText = `${this.oldCodeCountdown}秒后重新获取`;
      
      this.oldCodeTimer = setInterval(() => {
        this.oldCodeCountdown--;
        this.oldCodeBtnText = `${this.oldCodeCountdown}秒后重新获取`;
        
        if (this.oldCodeCountdown <= 0) {
          clearInterval(this.oldCodeTimer);
          this.oldCodeDisabled = false;
          this.oldCodeBtnText = '获取验证码';
        }
      }, 1000);
    },
    
    // 新邮箱倒计时
    startNewCodeCountdown() {
      this.newCodeDisabled = true;
      this.newCodeCountdown = 60;
      this.newCodeBtnText = `${this.newCodeCountdown}秒后重新获取`;
      
      this.newCodeTimer = setInterval(() => {
        this.newCodeCountdown--;
        this.newCodeBtnText = `${this.newCodeCountdown}秒后重新获取`;
        
        if (this.newCodeCountdown <= 0) {
          clearInterval(this.newCodeTimer);
          this.newCodeDisabled = false;
          this.newCodeBtnText = '获取验证码';
        }
      }, 1000);
    },
  beforeDestroy() {
    // 组件销毁前清除定时器
    clearInterval(this.oldCodeTimer);
    clearInterval(this.newCodeTimer);
  },
     //提交验证码的新方法
    submitnew() {
      const reg = /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;
      if (!this.gptsUserEmail || this.gptsUserEmail === 'null') {
        if (!this.form.email) {
          this.$message.error("请输入邮箱账号");
          return false;
        }
        if (!reg.test(this.form.email)) {
          this.$message.error("请输入正确的邮箱账号");
          return false;
        }
        if (!this.form.code) {
          this.$message.error("请输入验证码");
          return false;
        }
        bindEmail({
          gptsUserEmail: this.form.email,
          code: this.form.code,
          gptsUserId: this.userId,
        }).then((res) => {
          if (res.code === 200) {
            this.$message.success("绑定成功");
            this.$router.push('/secureMobile');
            // localStorage.setItem('gptsUserEmail', this.form.email);
            // window.location.reload();
          } else {
            this.$message.error(res.msg || "绑定失败");
          }
        })
      } else {
        if (!this.form.newemail) {
          this.$message.error("请输入邮箱账号");
          return false;
        }
        if (!reg.test(this.form.newemail)) {
          this.$message.error("请输入正确的邮箱账号");
          return false;
        }
        if (!this.form.code) {
          this.$message.error("请输入验证码");
          return false;
        }
        if (!this.form.newcode) {
          this.$message.error("请输入验证码");
          return false;
        }
        changeEmail(
          {
            gptsUserId: this.userId,
            newEmail: this.form.newemail,
            oldCode: this.form.code,
            newCode: this.form.newcode,
            oldEmail: this.gptsUserEmail,
          }).then((res) => {
            if (res.code === 200) {
              this.$message.success("修改成功");
              // 成功后更新显示的邮箱账号
              this.currentEmail = this.form.newemail;
              // 更新本地存储
              localStorage.setItem('gptsUserEmail', this.currentEmail);
              window.location.reload(true);
            } else {
              this.$message.error(res.msg || "修改失败");
              // 失败时保持原手机号显示
            }
          })
      }
    },
    //获取验证码 并只验证手机号 是否正确
    getCode() {
      const reg = /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;
      if (!this.form.email) {
        this.$message.error("请输入邮箱");
        return false;
      }
      if (!reg.test(this.form.email)) {
        this.$message.error("请输入正确的邮箱号");
        return false;
      }

      this.show = true;
    },
    tackBtn() {
      //验证码倒数60秒
      let time = 60;
      let timer = setInterval(() => {
        if (time == 0) {
          clearInterval(timer);
          this.setCode = "获取中...";
          this.disabled = false;
        } else {
          this.disabled = true;
          this.setCode = time + "秒后重试";
          time--;
        }
      }, 1000);
    },
    submit() {
      const reg = /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;
      if (!this.form.email) {
        this.$message.error("请输入邮箱");
        return false;
      }
      if (!reg.test(this.form.email)) {
        this.$message.error("请输入正确的邮箱");
        return false;
      }
      if (!this.form.code) {
        this.$message.error("请输入验证码");
        return false;
      }
      this.form.token = localStorage.getItem("Zyaccess_token"); // 竹云token
      this.form.language = this.languageSelect;
      upEmail(this.form).then(() => {
        this.$message({
          message: "修改成功！", //提示的信息
          type: "success", //类型是成功
          duration: 1200, //显示时间, 毫秒。设为 0 则不会自动关闭，建议1200
          onClose: () => {
            location.reload();
            //跳转页面或执行方法
            this.getUserCom();
            //跳转页面或执行方法
            this.$router.go(-1);
          },
        });
      });
    },
    getCodeEn() {
      const reg = /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;
      if (!this.form.email) {
        this.$message.error("Please enter email");
        return false;
      }
      if (!reg.test(this.form.email)) {
        this.$message.error("Please enter the correct email number");
        return false;
      }
      this.show = true;
    },
    tackBtnEn() {
      //验证码倒数60秒
      let time = 60;
      let timer = setInterval(() => {
        if (time == 0) {
          clearInterval(timer);
          this.setCodeEn = "Verification code";
          this.disabled = false;
        } else {
          this.disabled = true;
          this.setCodeEn = "Try again in" + time + " secondS";
          time--;
        }
      }, 1000);
    },
    submitEn() {
      const reg = /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;
      if (!this.form.email) {
        this.$message.error("Please enter email");
        return false;
      }
      if (!reg.test(this.form.email)) {
        this.$message.error("Please enter the correct email address");
        return false;
      }
      if (!this.form.code) {
        this.$message.error("Please enter the verification code");
        return false;
      }
      this.form.token = localStorage.getItem("Zyaccess_token"); // 竹云token
      this.form.language = this.languageSelect;
      upEmail(this.form).then(() => {
        this.$message({
          message: "Modified successfully！", //提示的信息
          type: "success", //类型是成功
          duration: 1200, //显示时间, 毫秒。设为 0 则不会自动关闭，建议1200
          onClose: () => {
            //跳转页面或执行方法
            this.getUserCom();
            //跳转页面或执行方法
            this.$router.go(-1);
          },
        });
      });
    },
  },
};
</script>
<style scoped lang="scss">
.gery .el-select {
  width: 100%;
  background: #f5f5f7 !important;
  border-radius: 5px;
}
.gray{

}
.box {
  background: #fff;
  .ViewTitle {
    height: 45px;
    line-height: 45px;
    border-bottom: 1px solid #ebebeb;
    font-size: 16px;
    color: #333333;
    font-weight: 400;
    padding: 0 50px;
    text-align: center;
  }
  .contain {
    padding: 25px 15px;
    width: 100vw;
    position: relative;
    .el-form-item {
      margin-bottom: 20px;
    }
    .submit {
      width: 320px;
      height: 56px;
      line-height: 56px;
      text-align: center;
      border-radius: 5px;
      margin: 30px auto 20px auto;
      background: var(--main-color);
      color: #ffffff;
      cursor: pointer;
    }
  }
  .codeBox {
    .el-form-item__content {
      width: 200px !important;
      position: relative;
    }
    .setCode {
      position: absolute;
      right:-20px;
      width: 110px;
      height: 48px;
      // line-height: 50px;
      text-align: center;
      border-radius: 4px;
      background: var(--main-color);
      color: #fff;
      font-size: 14px;
      margin-left: 15px;
    }
  }
  ::v-deep {
    .el-form-item__content {
      width: 200px;}
    .el-input__inner {
      width: 60vw;
      height: 48px;
      font-size: 14px;
      background-color: #fff;
    }

    .el-form-item__label {
      color: #666;
      font-size: 14px;
      padding-right: 25px;
      line-height: 48px;
    }
  }
}

::v-deep {
  .el-input__inner {
    height: 48px;

  }

  .el-form-item__label {
    color: #666;
    font-size: 14px;
    padding-right: 32px;
    line-height: 48px;
  }
  .codeBox {
    .el-form-item__content {
      .el-input {
        flex: 1;
      }
      .setCode {
        width: 75px;
        height: 48px;
        // line-height: 50px;
        text-align: center;
        border-radius: 4px;
        background: var(--main-color);
        color: #fff;
        font-size: 14px;
        margin-left: 15px;
      }
    }
  }
}
</style>
